"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickSearchModule = void 0;
const tslib_1 = require("tslib");
const AdaptableModuleBase_1 = require("./AdaptableModuleBase");
const ModuleConstants = tslib_1.__importStar(require("../Utilities/Constants/ModuleConstants"));
const QuickSearchStatusBarContent_1 = require("../View/QuickSearch/QuickSearchStatusBarContent");
class QuickSearchModule extends AdaptableModuleBase_1.AdaptableModuleBase {
    constructor(api) {
        super(ModuleConstants.QuickSearchModuleId, ModuleConstants.QuickSearchFriendlyName, 'search-table', 'QuickSearchPopup', 'Quickly highlight all cells in the grid that contain matching query text', api);
    }
    getViewProperties() {
        return {
            getStatusBarPanelProps() {
                return {
                    content: QuickSearchStatusBarContent_1.QuickSearchStatusBarContent,
                };
            },
        };
    }
}
exports.QuickSearchModule = QuickSearchModule;
